import React from 'react';

const ListVisorBody = props => {
  return <div {...props} className={ListVisorBody.baseClass} />;
};

ListVisorBody.baseClass = 'tk-list-visor-body';

export default ListVisorBody;
